import { forwardRef } from 'react';

import { useTranslate } from '../../../../../../../../hooks/useTranslate';
import { Initial } from './components/Initial/Initial';
import { Itinerary } from './components/Itinerary/Itinerary';
import { ServerError } from './components/ServerError/ServerError';
import { Author, Avatar, Bubble, Wrapper } from './Message.styles';
import { ItineraryMessage, Message as MessageProps } from './Message.types';

interface Props extends MessageProps {
  onTryAgainClicked: (prompt: string) => void;
  onViewTripClicked: (
    prompt: string,
    aiResponse: ItineraryMessage['content']
  ) => void;
}

export const Message = forwardRef<HTMLDivElement, Props>(
  ({ payload, author, onTryAgainClicked, onViewTripClicked }, ref) => {
    const { t } = useTranslate();

    return (
      <Wrapper ref={ref} author={author}>
        <div>
          <Author>
            {author === 'amelia' && (
              <Avatar src="/m/amelia-avatar@2x.png" alt="Amelia avatar" />
            )}

            {t(`explore.amelia.author.${author}`)}
          </Author>

          <Bubble author={author}>
            {payload.type === 'plain' && payload.content}
            {payload.type === 'initial' && <Initial />}
            {payload.type === 'itinerary' && (
              <Itinerary
                content={payload.content}
                onViewTripClicked={() =>
                  onViewTripClicked(payload.prompt, payload.content)
                }
              />
            )}
            {payload.type === 'server-error' && (
              <ServerError
                onTryAgainClicked={() => onTryAgainClicked(payload.prompt)}
              />
            )}
          </Bubble>
        </div>
      </Wrapper>
    );
  }
);

Message.displayName = 'Message';
